






















import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

import { IBlueprintField } from "@/models/provisioning";

@Component
export default class ViewFieldsValuesModal extends Vue {
  // Props

  @Prop({ required: true })
  public requestFields!: IBlueprintField[];

  // Methods

  public getValue(requestField: IBlueprintField) {
    const valueOptions = requestField.options;
    const defaultValue = requestField.default_value;

    if (!_.isEmpty(valueOptions))
      return _.get(
        _.find(valueOptions, ["value", defaultValue]),
        "label",
        "--"
      );

    return _.isNull(defaultValue) || _.isUndefined(defaultValue)
      ? "--"
      : defaultValue;
  }
}
